import { SVGProps } from 'react';

const Panda = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m15 12 2 2m1-7.5a.5.5 0 0 0-.5-.5m3.19 3.67a4.499 4.499 0 1 0-7.04-5.5 8.4 8.4 0 0 0-3.3 0 4.5 4.5 0 1 0-7.04 5.5C2.49 11.2 2 12.88 2 14.5 2 19.47 6.48 22 12 22s10-2.53 10-7.5c0-1.62-.48-3.3-1.3-4.83M6 6.5a.495.495 0 0 1 .5-.5M9 12l-2 2m4.25 3.25h1.5L12 18z"
    />
  </svg>
);
export default Panda;
